import React from 'react'

function Featured() {
    return (
        <>
            <div className="color-scheme-1 block">
                <div className="container">
                    <div className="section-sub-title center">
                        <article className="section-title-body white">
                            <h1 className="head-title">
                                <span style={{ fontWeight: '700' }}>
                                    WHAT WE DO AT A GLANCE
                                </span>
                            </h1>

                            {/* <p className="head-text">
                                Excepteur sint occaecat cupidatat non proident, sunt sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit in culpa qui sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit officia deserunt mollit anim id est laborum.
                            </p> */}
                        </article>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 order-md-0 order-lg-1">
                            <div className="moon-block">
                                <span className="moon"></span>
                                <img alt="" className="img-fluid" src="img/preview/feature.png"/>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 order-md-1 order-lg-0">
                            <div className="feature">
                                    <article className="widget-block1 right">
                                        <h1 style={{fontSize:'24px'}}  className="head-title hra-topTitle">Celebrate Culture</h1>
                                        <p>
                                            Through spectacular festivals, parades, competitions, and community gatherings, FOG brings families and communities together. 
                                        </p>
                                    </article>
                                    <br/>
                                    <article className="widget-block1">
                                        <h1 style={{fontSize:'24px'}} className="head-title hra-topTitle">Strengthen Civic Engagement</h1>
                                        <p>
                                            Through education, training, and mobilization, we empower Hindu Americans to participate confidently in U.S. democracy.
                                        </p>
                                    </article>
                                    {/* <article className="widget-block right d-lg-none d-xl-block">
                                        <h4 className="widget-title">Strengthen Civic Engagement</h4>
                                        <p>
                                            Through voter education, policy briefings, training academies, and mobilization drives, we ensure every Hindu American can participate confidently in the U.S. democratic process.
                                        </p>
                                    </article>
                                    <article className="widget-block right d-lg-none d-xxl-block">
                                        <h4 className="widget-title">Build Community Alliances</h4>
                                        <p>
                                            We foster local and national partnerships across religious, cultural, professional, and policy spheres — including Hindu-Jewish, Hindu-Christian, Hindu-Latino, and interfaith networks.
                                        </p>
                                    </article> */}
                            </div>
                        </div>
                        <div className="col-lg-3  col-md-6  order-md-2  order-lg-3">
                        <div className="feature">
                                <article className="widget-block1 right">
                                    <h1 style={{fontSize:'24px'}}  className="head-title hra-topTitle">Empower Leaders</h1>
                                    <p>
                                        Our training programs prepare youth, women, professionals, and community members to become confident leaders in civic, public policy, and political spaces.
                                    </p>
                                </article>
                                <br/>
                                <article className="widget-block1">
                                    <h1 style={{fontSize:'24px'}} className="head-title hra-topTitle">Build Community Alliances</h1>
                                    <p>
                                        We foster local and national partnerships across religious, cultural, professional, and policy spheres - including Hindu-Jewish, Hindu-Christian, Hindu-Latino, and interfaith networks.
                                    </p>
                                </article>
                                {/* <article className="widget-block d-lg-none d-xl-block">
                                    <h4 className="widget-title">Unique Design</h4>
                                    <p>
                                        Teur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                    </p>
                                </article>
                                <article className="widget-block d-lg-none d-xxl-block">
                                    <h4 className="widget-title">Landing Page</h4>
                                    <p>
                                        Sunt in culpa qui officia deserunt mollit anim id est laborum.
                                    </p>
                                </article> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}

export default Featured
